import React from 'react';

interface Props {
  isHistoric: boolean;
  isDraggable: boolean;
}

const AlertStatusHeader = ({ isHistoric, isDraggable }: Props) => {
  const isActiveStatus = !isHistoric;
  return (
    <tr>
      {isDraggable && <th />}
      <th>Name</th>
      <th>Code</th>
      <th>Alert sub-type</th>
      <th>Entity type</th>
      <th>Valid from</th>
      {isHistoric && <th>Valid until</th>}
      <th className='text-center'>Final</th>
      <th className='text-center'>Goodlisting</th>
      {isActiveStatus && <th />}
    </tr>
  );
};

export default AlertStatusHeader;
